import { VersionTeamConnection } from '../../types/versionTeam';
import {BaseConnectionService} from './baseConnectionService';

class VersionTeamConnectionService extends BaseConnectionService<VersionTeamConnection> {
    constructor() {
        super('versionteams');
    }
}

export const versionTeamConnectionService = new VersionTeamConnectionService();